<!-- For each slot, show employee selector thing -->

<div *ngFor="let assignment of slotAssignments; let i = index" class="slot" [class.animate]="animateIndices[i]">
    <div class="order-selector" *ngIf="assigningOrder">
        <mat-icon (click)="decreaseOrder(assignment)" svgIcon="chevronUp"></mat-icon>
        <mat-icon (click)="increaseOrder(assignment)" svgIcon="chevronDown"></mat-icon>
    </div>

    <div
        class="employee-selector"
        [attr.data-cy]="'employee-selector-' + (i + 1)"
        [attr.data-cy-value]="assignment.employee?.fullName"
    >
        <mat-form-field>
            <mat-label>
                <span class="slot-name">
                    <ng-container *ngIf="assigningOrder">{{ assignment.order }}. </ng-container
                    >{{ assignment.slot.name | appTranslateOptions: slotDisplayOptions }}</span
                ></mat-label
            >
            <ui-employee-autocomplete
                [name]="'employee' + assignment.slot.id"
                [allowNone]="allowNone"
                [customQuery]="employeeAutocompleteQuery"
                [required]="isRequired"
                [(ngModel)]="assignment.employee"
                [class.permanently-assigned]="assignment.permanentSlotAssignment !== null"
                [subTitleResolver]="subTitleFunctionBuilder(assignment.slot)"
                #employeeSelector="ngModel"
                (ngModelChange)="onModelChange($event, assignment)"
            >
            </ui-employee-autocomplete>
            <mat-error *ngIf="employeeSelector.invalid">{{ employeeSelector.errors | formErrors }}</mat-error>
            <mat-hint>{{ assignment.hint }}</mat-hint>
        </mat-form-field>

        <mat-checkbox
            *ngIf="!isSettingDefaultAssignment"
            [name]="'setAsPermanent' + assignment.slot.id"
            [(ngModel)]="assignment.permanentSlotAssignment"
            >{{ 'forms.multi-signer-assignment.saveEmployeeToThisRole' | appTranslate }}
        </mat-checkbox>
    </div>
</div>
